let datePickerModulePromise = null;

/**
 * Fetches the react-datepicker chunk once. A failed fetch is forgotten so the next
 * open can retry instead of reusing the rejected promise.
 */
export function loadDatePicker() {
  if (!datePickerModulePromise) {
    datePickerModulePromise = import(/* webpackChunkName: "react-datepicker" */ 'react-datepicker').catch(
      (error) => {
        datePickerModulePromise = null;
        throw error;
      },
    );
  }
  return datePickerModulePromise;
}

export function resetDatePickerLoaderForTests() {
  datePickerModulePromise = null;
}
